if (!customElements.get('adev-horizontal-scroller')) {
    customElements.define(
        'adev-horizontal-scroller',
        class AdevHorizontalScroller extends HTMLElement {
            constructor() {
                super();
                this.isDown = false;
                this.preventClick = false;
                this.startX = 0;
                this.scrollStartLeft = 0;

                this.isScrollable = false;
                this.isScrolled = false;
                this.isAtLeft = false;
                this.isAtRight = false;
            }

            connectedCallback() {
                this.classList.add("adev-horizontal-scroller");

                this.addEventListener("mousedown", this.handleMouseDown.bind(this));
                this.addEventListener("mouseleave", this.handleMouseLeave.bind(this));
                this.addEventListener("mouseup", this.handleMouseUp.bind(this));
                this.addEventListener("mousemove", this.handleMouseMove.bind(this));
                this.addEventListener("click", this.handleClick.bind(this));

                this.querySelectorAll("img,a,button").forEach(child => {
                    child.addEventListener("dragstart", e => e.preventDefault());
                });

                this.updateScrollState();
                window.addEventListener("resize", () => this.updateScrollState());
                this.addEventListener("scroll", () => this.updateScrollState());
                this.addEventListener("adev:refresh", () => this.updateScrollState());
            }

            handleMouseDown(e) {
                this.isDown = true;
                this.classList.add("adev-dragging");
                this.style.cursor = "grabbing";
                this.startX = e.pageX - this.offsetLeft;
                this.scrollStartLeft = this.scrollLeft;
                this.preventClick = false;
            }

            handleMouseLeave() {
                this.isDown = false;
                this.classList.remove("adev-dragging");
                this.style.cursor = "grab";
            }

            handleMouseUp() {
                this.isDown = false;
                this.classList.remove("adev-dragging");
                this.style.cursor = "grab";
            }

            handleMouseMove(e) {
                if (!this.isDown) return;
                e.preventDefault();
                const x = e.pageX - this.offsetLeft;
                const walk = (x - this.startX) * 3;
                this.scrollLeft = this.scrollStartLeft - walk;
                this.preventClick = true;
            }

            handleClick(e) {
                if (this.preventClick) {
                    e.stopPropagation();
                    e.preventDefault();
                }
            }

            updateScrollState() {
                const scrollLeft = this.scrollLeft;
                const scrollWidth = this.scrollWidth;
                const clientWidth = this.clientWidth;

                this.isScrollable = scrollWidth > clientWidth;
                this.isScrolled = scrollLeft > 0;
                this.isAtLeft = scrollLeft === 0;
                this.isAtRight = Math.ceil(scrollLeft + clientWidth) >= scrollWidth;

                let classes = [];

                if (this.isScrollable) classes.push("adev--scrollable");
                if (this.isScrolled) classes.push("adev--scrolled");
                if (!this.isAtLeft) classes.push("adev--scrollable-left");
                if (!this.isAtRight) classes.push("adev--scrollable-right");

                this.classList.remove(
                    "adev--scrollable",
                    "adev--scrolled",
                    "adev--scrollable-left",
                    "adev--scrollable-right"
                );
                this.classList.add(...classes);
            }
        }
    );
}

if (!customElements.get('adev-product-card')) {
    customElements.define('adev-product-card', class adevProductCard extends HTMLElement {
        constructor() {
            super();
        }        

        initVariantsPicker(){
            this.querySelectorAll('[data-adev-product-card="variant-option"]').forEach(option => {

                const selectedValueEl = option.querySelector('[data-adev-product-card="variant-option-selected-value"]');

                option.querySelectorAll('[data-adev-product-card="variant-option-value"]').forEach(input => {
                    input.addEventListener('change', () => {
                        if (selectedValueEl) {
                            selectedValueEl.innerText = input.value;
                        }

                        this.refresh();
                    })
                });

            });
        }

        setCurrentVariant(){
            const checkedInputs = this.querySelectorAll('[data-adev-product-card="variant-option-value"]:checked');

            if (checkedInputs.length > 0) {
                this.variantOptions = Array.from(checkedInputs).map(input => {
                    return input.value;
                });

                this.currentVariant = this.variantsData.find((variant) => {
                    return !variant.options.map((option, index) => {
                        return this.variantOptions[index] === option
                    })
                    .includes(false);
                });
            } else {
                this.currentVariant = this.variantsData[0];
            }
        }

        updateMediaGallery(){
            const mediaGalleryEl = this.querySelector('adev-card-images');

            if (mediaGalleryEl && this.currentVariant) {
                
                if(this.currentVariant.featured_image !== null) {
                    const mediaID = this.currentVariant.featured_image.id;
                    
                    const mediaIndex = this.querySelector(`[data-adev-product-card="media-gallery-item"][data-media-id="${mediaID}"]`);
                    if(mediaIndex){
                        const index = parseInt(mediaIndex.dataset.index, 10);
                        mediaGalleryEl.updateCurrentMedia(index);
                    }
                }
            }
        }

        updateLinks(){
            const productLinkEls = this.querySelectorAll('[data-adev-product-card="product-link"]');
            if (this.currentVariant) {
                productLinkEls.forEach(linkEl => {
                    const url = new URL(linkEl.href);
                    url.searchParams.set('variant', this.currentVariant.id);
                    linkEl.href = url.toString();
                });
            }
        }

        refresh(){
            this.setCurrentVariant();
            this.updateMediaGallery();
            this.updateLinks();
        }

        connectedCallback() {
            const jsonEl = this.querySelector('script[data-adev-product-card="json"]');
            if (!jsonEl) return;

            this.variantsData = JSON.parse(jsonEl.textContent);

            this.setCurrentVariant();

            this.initVariantsPicker();
        }

        disconnectedCallback() {
            
        }

    });
}

if (!customElements.get('adev-card-images')) {
    customElements.define('adev-card-images', class adevCardImages extends HTMLElement {
        constructor() {
            super();
        }
        
        
        initSlider(){
            this.sliderEl = new Flickity(this, {
                cellAlign: 'left',
                contain: true,
                wrapAround: true,
                prevNextButtons: false,
                pageDots: true,
                initialIndex: this.dataset.initialIndex ? parseInt(this.dataset.initialIndex, 10) : 0,
            });
        }

        destroySlider(){
            if(this.sliderEl){
                this.sliderEl.destroy();
            }
        }

        updateCurrentMedia(index){
            if(this.sliderEl){
                this.sliderEl.select(index);
            }
        }

        connectedCallback() {
            this.initSlider();
        }

        disconnectedCallback() {
            this.destroySlider();
        }

    });
}

document.querySelectorAll('[data-adev-go-to]').forEach(element => {
    
    element.addEventListener('click', () => {
        const url = element.getAttribute('data-adev-go-to');
        if (url) {
            window.location.assign(url);
        }
    })

});
